import React from 'react'

export const topFiveStats = (statsArray, property) => {
    return statsArray.sort((a, b) => b[property] - a[property]).slice(0, 5);
}